// 「選択操作の左右反転」の有効/無効をローカルストレージに保存するユーティリティ。
// 既定は OFF（不在時は false）。値は "on" / "off" の文字列。
//
// OFF（既定）: 空白部の左ドラッグ=キャンバス移動、右ドラッグ=範囲選択（従来の操作）。
// ON        : 空白部の右ドラッグ=キャンバス移動、左ドラッグ=範囲選択（左右を反転）。
// いずれのモードでも、図形の選択は左シングルクリック、図形のコンテキストメニューは右シングルクリック。

const STORAGE_KEY = "refinement-canvas:select-pan-invert";

export function loadSelectPanInvertPreference(): boolean {
  try {
    if (typeof localStorage === "undefined") return false;
    return localStorage.getItem(STORAGE_KEY) === "on";
  } catch {
    return false;
  }
}

export function saveSelectPanInvertPreference(enabled: boolean): void {
  try {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(STORAGE_KEY, enabled ? "on" : "off");
  } catch {
    // 保存できない場合は無視（プライベートブラウジング等）。
  }
}
